import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useEffect,
} from "react";

const ThemeContext = createContext({});

export const ThemeProvider = ({ children }) => {
  const storageKey = "@HubEverlog:darkMode";
  const getInitialTheme = () => {
    if (typeof window === "undefined") {
      return true;
    }
    const storedValue = window.localStorage.getItem(storageKey);
    if (storedValue === null) {
      return true;
    }
    return storedValue === "true";
  };

  const [darkMode, setDarkMode] = useState(getInitialTheme);

  const setTheme = useCallback((theme) => {
    setDarkMode(theme);
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }
    window.localStorage.setItem(storageKey, String(darkMode));
    if (darkMode) {
      document.body.classList.remove("white-content");
    } else {
      document.body.classList.add("white-content");
    }
  }, [darkMode, storageKey]);

  return (
    <ThemeContext.Provider
      value={{
        darkMode,
        setTheme,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);

  if (!context) {
    throw new Error("useTheme must be used within an AuthProvider");
  }
  return context;
};
